var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFileText = function SvgFileText(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16634 1.16666H3.49967C3.19026 1.16666 2.89351 1.28957 2.67472 1.50837C2.45592 1.72716 2.33301 2.0239 2.33301 2.33332V11.6667C2.33301 11.9761 2.45592 12.2728 2.67472 12.4916C2.89351 12.7104 3.19026 12.8333 3.49967 12.8333H10.4997C10.8091 12.8333 11.1058 12.7104 11.3246 12.4916C11.5434 12.2728 11.6663 11.9761 11.6663 11.6667V4.66666L8.16634 1.16666Z",
    stroke: "#6280DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16699 1.16666V4.66666H11.667",
    stroke: "#6280DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33366 7.58334H4.66699",
    stroke: "#6280DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33366 9.91666H4.66699",
    stroke: "#6280DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83366 5.25H5.25033H4.66699",
    stroke: "#6280DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFileText, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/file-text.4867f6b3.svg";
export { ForwardRef as ReactComponent };